module.exports = __webpack_public_path__ + "static/media/15UN-Habitat16.ce857a3c.jpg";